import { VesselVisitGridComponent } from './../vessel-visit-grid/vessel-visit-grid.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseListComponent } from '@common/classes/base-list';
import { VesselVisitPermissions } from '@common/classes/permissions';
import { CommonService } from '@common/services/common.service';
import { VesselVisitCreateComponent } from '../vessel-visit-create/vessel-visit-create.component';
import { ViewMode } from '@common/models/view-mode';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-vessel-visit-list',
    templateUrl: './vessel-visit-list.component.html',
    styleUrls: ['./vessel-visit-list.component.scss'],
    providers: [CommonService]
})
export class VesselVisitListComponent extends BaseListComponent {
    queryName = 'VesselVisits';
    createPermission = VesselVisitPermissions.Action.Create;

    breadcrumb = [
        {
            icon: 'ship',
            title: 'Vessel Visits'
        },
        {
            icon: 'ship',
            title: 'Vessel Visit List'
        }
    ];

    @ViewChild(VesselVisitGridComponent) visitGrid: VesselVisitGridComponent;

    constructor(
        common: CommonService,
        protected toastrService: ToastrService
    ) { super(common); }

    override search() {
        return super.search(this.visitGrid.appGrid.grid);
    }

    override async createNew() {        
        const data = await this.dialogService.open(VesselVisitCreateComponent, { size: 'xl' } );

        if (data!=null && data.id) {
            this.toastrService.success(this.translateService.instant('New vessel visit has successfully been created.'));
            this.router.navigate(['/vessel-visit/view', data.id]);  
            this.consoleWindowService.close();
        }
    }
}
